<template>
  <div>
    <el-form>
    <el-form-item label="占位内容：" label-width="100px" label-position="left">
      <el-input v-model="data.placeholder"
                placeholder="占位内容"></el-input>
    </el-form-item>
    <!-- <el-form-item label="默认值：" label-width="100px" label-position="left">
      <el-input v-model="data.valueDefault"
                placeholder="默认值"></el-input>
    </el-form-item> -->
      <el-form-item label="默认值：" label-width="100px" label-position="left">
      <el-input v-model="data.value"
                placeholder="默认值"></el-input>
    </el-form-item>
    <el-form-item label="字典配置：" label-position="left"><br>
      <el-tabs v-model="data.dicOption"
               stretch
               @tab-click="handleTabClick">
        <el-tab-pane label="静态数据："
                     name="1">
          <el-tree ref="tree"
                   :data="dicdata"
                   default-expand-all
                   draggable
                   node-key="value"
                   :expand-on-click-node="false">
            <span class="custom-tree-node"
                  slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button type="text"
                           size="mini"
                           icon="el-icon-plus"
                           @click="handleNodeAdd(data)"></el-button>
                <!--                <el-button class="warning" type="text" size="mini" icon="el-icon-edit"-->
                <!--                           @click="handleNodeEdit(data)"></el-button>-->
                <el-button class="danger"
                           type="text"
                           size="mini"
                           icon="el-icon-delete"
                           @click="handleNodeRemove(node, data)"></el-button>
              </span>
            </span>
          </el-tree>
          <div style="margin-left: 22px;">
            <el-button type="text"
                       @click="handleParentNodeAdd">添加父级
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="远端数据："
                     name="2">
          网址
          <el-input v-model="data.dicUrl"
                    placeholder="远端数据字典网址"></el-input>
          请求方法
          <el-select v-model="data.dicMethod"
                     placeholder="请求方法"
                     style="width: 100%;">
            <el-option label="POST"
                       value="post"></el-option>
            <el-option label="GET"
                       value="get"></el-option>
          </el-select>
            标签
            <el-input v-model="data.props.label"
                      placeholder="远端数据字典网址"></el-input>
            属性
            <el-input v-model="data.props.value"
                      placeholder="远端数据字典网址"></el-input>
        </el-tab-pane>
      </el-tabs>
    </el-form-item>
    <el-form-item label="选项分隔符：">
      <el-input v-model="data.separator"
                placeholder="选项分隔符"></el-input>
    </el-form-item>
    <el-form-item label="联动URL：" label-width="100px" label-position="left">
      <el-input v-model="data.casUrl"></el-input>
    </el-form-item>
    <el-form-item label="是否显示选中值的完整路径：">
      <el-switch v-model="data.showAllLevels"></el-switch>
    </el-form-item>
    <el-form-item label="是否可清空：">
      <el-switch v-model="data.clearable"></el-switch>
    </el-form-item>
    <el-form-item label="是否可搜索：">
      <el-switch v-model="data.filterable"></el-switch>
    </el-form-item>
    <el-form-item label="是否禁用：">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见：">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="列隐藏：" v-if="isDynamic">
      <el-switch v-model="data.hide"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填：">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialogVisible"
               :rules="dialogRules"
               :before-close="beforeClose">
      <el-form ref="dialogForm"
               :model="dialogForm"
               label-width="80px">
        <el-form-item label="label">
          <el-input v-model="dialogForm.label"
                    placeholder="label"></el-input>
        </el-form-item>
        <el-form-item label="value">
          <el-input v-model="dialogForm.value"
                    placeholder="value"
                    :type="this.dialogInputType">
            <el-select v-model="dialogInputType"
                       slot="append"
                       placeholder="数据类型"
                       style="width: 100px">
              <el-option label="String"
                         value="text"></el-option>
              <el-option label="Number"
                         value="number"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="handleDialogAdd"
                   v-if="dialogStatus == 'add'">确 定</el-button>
        <!--        <el-button type="primary" @click="handleDialogUpdate" v-else>确 定</el-button>-->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixinIsDynamic from '../../mixins/isDynamic'
export default {
  mixins: [mixinIsDynamic],
  name: 'ConfigCascader',
  props: ['data', 'widgetForm'],
  data() {
    return {
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      },
      dicOption: '1',
      dicCopy: this.deepClone(this.data.dicData),
      dicdata: this.deepClone(this.data.dicData),
      dialogForm: {},
      dialogVisible: false,
      dialogRules: {
        label: { required: true, message: '请输入label' },
        value: { required: true, message: '请输入value' }
      },
      dialogStatus: 'add',
      selectData: undefined,
      dialogInputType: 'text'
    }
  },
  methods: {
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    },
    handleTabClick(tab) {
      const { name } = tab
      if (name === '1') {
        this.data.dicUrl = ''
        delete this.data.dicMethod
        delete this.data.remote
        this.data.props = {}
        this.dicdata = [
          {
            label: '选项一',
            value: '0',
            children: [{
              label: '选项1-1',
              value: '11'
            }, {
              label: '选项1-2',
              value: '12'
            }]
          },
          { label: '选项二', value: '1' },
          { label: '选项三', value: '2' }
        ]
        this.data.dicData = []

        /* if (this.data.dicData.length == 0)
          this.data.dicData = this.dicCopy*/
      } else {
        this.data.dicUrl = ''
        this.data.remote = true
        // this.dicdata = this.data.dicData

        delete this.data.dicData

        /* this.data.dicData = []

        */
      }
    },
    handleParentNodeAdd() {
      this.selectData = undefined
      this.dialogStatus = 'add'
      this.dialogVisible = true
    },
    handleNodeAdd(data) {
      this.selectData = data
      this.dialogStatus = 'add'
      this.dialogVisible = true
    },
    handleNodeRemove(node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.label === data.label && d.value === data.value)
      children.splice(index, 1)
    },
    handleDialogAdd() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          const { label, value } = this.dialogForm
          const node = this.$refs.tree.getNode(value)
          if (node) this.$message.error('value重复')
          else {
            const data = this.selectData
            const newNode = {
              label,
              value: this.dialogInputType == 'number' ? Number(value) : value
            }
            if (data) {
              if (!data.children) this.$set(data, 'children', [])
              data.children.push(newNode)
            } else {
              this.$set(this.data.dicData, this.data.dicData.length, newNode)
            }
            this.beforeClose()
          }
        }
      })
    },
    beforeClose() {
      this.$refs.dialogForm.clearValidate()
      this.dialogForm = {}
      this.dialogVisible = false
    }
  },
  watch: {
    'data.required': function(val) {
      if (val) this.validator.required = { required: true, message: `请选择${this.data.label}` }
      else this.validator.required = null

      this.generateRule()
    },
    'data.dicData': {
      handler(val) {
        if (val && val.length > 0 && !Object.is(val, this.dicdata)) {
          this.dicdata = this.deepClone(val)
        }
      },
      deep: true
    },
    dicdata: {
      handler(val) {
        if (val && val.length > 0 && !Object.is(val, this.data.dicData)) {
          console.log(val)
          this.data.dicData = val
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
